import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { INSTITUTIONAL_ICON_OPTIONS } from "../../../constants/institutionalIconOptions";

export default function InstitutionalIconPicker({ value, onChange, label = "Ícone" }) {
  const selected = String(value || "").trim();

  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
        {label} — clique para escolher
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(88px, 1fr))",
          gap: 0.75,
        }}
      >
        {INSTITUTIONAL_ICON_OPTIONS.map(({ id, label: lbl, Icon }) => {
          const active = selected === id;
          return (
            <Button
              key={id}
              size="small"
              variant={active ? "contained" : "outlined"}
              onClick={() => onChange(id)}
              sx={{
                flexDirection: "column",
                py: 1,
                px: 0.5,
                minHeight: 72,
                textTransform: "none",
                fontSize: "0.7rem",
                lineHeight: 1.2,
              }}
            >
              <Icon sx={{ fontSize: 22, mb: 0.5 }} />
              {lbl}
            </Button>
          );
        })}
      </Box>
      {selected ? (
        <Button size="small" color="inherit" sx={{ mt: 0.5 }} onClick={() => onChange("")}>
          Remover ícone
        </Button>
      ) : null}
    </Box>
  );
}
